import React from "react";
import { Menu, MenuItem, IconButton, Tooltip, Button } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useTranslation } from "react-i18next";

interface CustomAction {
    label: string;
    onClick: () => void;
    color?: string;
}

interface SalesDocumentActionsProps {
    onCancel?: () => void;
    onCopy?: () => void;
    onDelete?: () => void;
    onPrint?: () => void;
    onSendEmail?: () => void;
    onPost?: () => void;
    onIntegrate?: () => void;
    onReintegrateTa?: () => void;
    onCreateReturn?: () => void;
    onRefund?: () => void;
    onReadyToShip?: () => void;
    customActions?: CustomAction[];

}
const SalesDocumentActions: React.FC<SalesDocumentActionsProps> = ({
    onCancel,
    onCopy,
    onDelete,
    onPrint,
    onPost,
    onSendEmail,
    onIntegrate,
    onReintegrateTa,
    onCreateReturn,
    onRefund,
    onReadyToShip,
    customActions

}) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { t } = useTranslation();
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Tooltip title="Actions">
                <Button variant="contained" onClick={handleClick}
                    endIcon={<MoreVertIcon />}
                    size="small"
                >
                    Actions
                </Button>

            </Tooltip>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {onReadyToShip && (
                    <MenuItem onClick={() => { handleClose(); onReadyToShip(); }}>
                        {t("common.readyToShip")}
                    </MenuItem>
                )}


                {onPost && (
                    <MenuItem onClick={() => { handleClose(); onPost(); }}>
                        {t("common.post")}
                    </MenuItem>
                )}
                {onRefund && (
                    <MenuItem onClick={() => { handleClose(); onRefund(); }}>
                        {t("common.refund")}
                    </MenuItem>
                )}
                {onCreateReturn && (
                    <MenuItem onClick={() => { handleClose(); onCreateReturn(); }}>
                        {t("common.createReturn")}
                    </MenuItem>
                )}
          
                {onCopy && (
                    <MenuItem onClick={() => { handleClose(); onCopy(); }}>
                        {t("common.copy")}
                    </MenuItem>
                )}
          
                {onPrint && (
                    <MenuItem onClick={() => { handleClose(); onPrint(); }}>
                        {t("common.print")}
                    </MenuItem>
                )}
                {onSendEmail && (
                    <MenuItem onClick={() => { handleClose(); onSendEmail(); }}>
                        {t("common.sendEmail")}
                    </MenuItem>
                )}
                {onIntegrate && (
                    <MenuItem onClick={() => { handleClose(); onIntegrate(); }}>
                        {t("common.integrate")}
                    </MenuItem>
                )}
                {onReintegrateTa && (
                    <MenuItem onClick={() => { handleClose(); onReintegrateTa(); }}>
                        {t("common.integrateTa")}
                    </MenuItem>
                )}
           

                {customActions?.map((action, idx) => (
                    <MenuItem
                        key={idx}
                        onClick={() => {
                            handleClose();
                            action.onClick();
                        }}
                        style={{ color: action.color ?? "inherit" }}
                    >
                        {action.label}
                    </MenuItem>
                ))}

          {onCancel && (
            <MenuItem sx={{ color: "red" }} onClick={() => { handleClose(); onCancel(); }}>
              {t("common.cancel_mak")}
            </MenuItem>
          )}
          {onDelete && (
            <MenuItem sx={{ color: "red" }} onClick={() => { handleClose(); onDelete(); }}>
              {t("common.delete")}
            </MenuItem>
          )}
            </Menu>
        </>
    );
};
export default SalesDocumentActions;